import React from "react";
import PropTypes from "prop-types";
import validator from "validator";

const propTypes = {
    to: PropTypes.string.isRequired
};

const defaultProps = {};

const Input = ({ ...props }) => <input {...props} />;

const TextArea = ({ ...props }) => <textarea {...props} />;

const ErrorMessage = ({ renderErrors, field }) => {
    if (field.isValid || !renderErrors || field.msg === "") {
        return null;
    }

    return (
        <div className="error">
            <span>{field.msg}</span>
        </div>
    );
};
export default class Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: {
                isValid: false,
                msg: ""
            },
            email: {
                isValid: false,
                msg: ""
            },
            subject: {
                isValid: false,
                msg: ""
            },
            message: {
                isValid: false,
                msg: ""
            }
        };

        this.handleSubmit = this.handleSubmit.bind(this);

        this.nameInput = React.createRef();
        this.emailInput = React.createRef();
        this.subjectInput = React.createRef();
        this.messageInput = React.createRef();

        this.renderErrors = false;
        this.formValid = false;
    }

    componentWillUpdate() {
        const { name, email, subject, message } = this.state;

        if (
            !name.isValid ||
            !subject.isValid ||
            !email.isValid ||
            !message.isValid
        ) {
            this.renderErrors = true;
            this.formValid = false;

            return;
        }

        this.formValid = true;
    }

    checkValidity(field) {
        if (field === false) {
            const fields = ["name", "email", "subject", "message"];

            fields.forEach(name => {
                this.checkValidity(name);
            });

            return;
        }

        switch (field) {
            case "name":
                this.setState({
                    name: {
                        isValid: !validator.isEmpty(
                            this.nameInput.current.value
                        ),
                        msg: "Name is required"
                    }
                });
                break;
            case "email":
                this.setState({
                    email: {
                        isValid: validator.isEmail(
                            this.emailInput.current.value
                        ),
                        msg: "Invalid e-mail address"
                    }
                });
                break;
            case "subject":
                this.setState({
                    subject: {
                        isValid: !validator.isEmpty(
                            this.subjectInput.current.value
                        ),
                        msg: "Please provide a subject"
                    }
                });
                break;
            case "message":
                this.setState({
                    message: {
                        isValid: !validator.isEmpty(
                            this.messageInput.current.value
                        ),
                        msg: "Please provide a subject"
                    }
                });
                break;
            default:
        }
    }

    handleSubmit(event) {
        this.checkValidity(false);
        if (!this.formValid) {
            event.preventDefault();
        }
    }

    render() {
        const { to } = this.props;
        const { form, name, email, subject, message } = this.state;

        return (
            <div className="contact-form">
                <form
                    onSubmit={this.handleSubmit}
                    name="contact"
                    method="POST"
                    action={`https://formspree.io/${to}`}
                >
                  <input type="hidden" name="form-name" value="contact" />

                    <div>
                        <div className="mb-5 relative">
                            <input
                                onChange={() => this.checkValidity("name")}
                                ref={this.nameInput}
                                type="text"
                                name="name"
                                placeholder="Name"
                            />
                            <ErrorMessage
                                field={name}
                                renderErrors={this.renderErrors}
                            />
                        </div>
                        <div className="mb-5">
                            <input
                                onChange={() => this.checkValidity("email")}
                                ref={this.emailInput}
                                className="u-width--100"
                                type="email"
                                name="email"
                                placeholder="E-mail Address"
                            />
                            <ErrorMessage
                                field={email}
                                renderErrors={this.renderErrors}
                            />
                        </div>
                    </div>

                    <div className="mb-5">
                        <input
                            onChange={() => this.checkValidity("subject")}
                            ref={this.subjectInput}
                            type="subject"
                            name="subject"
                            placeholder="Subject"
                        />

                        <ErrorMessage
                            field={subject}
                            renderErrors={this.renderErrors}
                        />
                    </div>

                    <div className="mb-5">
                        <textarea
                            onChange={() => this.checkValidity("message")}
                            ref={this.messageInput}
                            rows={5}
                            name="message"
                            placeholder="Message"
                        />

                        <ErrorMessage
                            field={message}
                            renderErrors={this.renderErrors}
                        />
                    </div>

                    <div>
                        <div className="cms-content">
                            <button className="button" type="submit">
                                Send
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
